import * as React from "react";

function CodeIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="25.246" height="15.962" viewBox="0 0 25.246 15.962">
  <g id="Icon_feather-code" data-name="Icon feather-code" transform="translate(97.5 8.707)">
    <path id="Path_52988" data-name="Path 52988" d="M24,23.547l7.274-7.274L24,9" transform="translate(-104.028 -17)" fill="none" stroke="#606060" stroke-linecap="round" stroke-linejoin="round" strokeWidth="1"/>
    <path id="Path_52989" data-name="Path 52989" d="M10.274,9,3,16.274l7.274,7.274" transform="translate(-100 -17)" fill="none" stroke="#606060" stroke-linecap="round" stroke-linejoin="round" strokeWidth="1"/>
  </g>
</svg>

  );
}

export default CodeIcon;
